import React, { useState, useEffect } from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { useAuth0 } from "@auth0/auth0-react";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    user,
    isAuthenticated,
    loginWithRedirect,
    logout,
    getAccessTokenSilently,
  } = useAuth0();
  const toggle = () => setIsOpen(!isOpen);

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });

  return (
    <>
      <style>
        {`
        .nav-container {
          // border: 1px red solid;
        }
        .login-buttons {
          // border: 1px green solid;
          display: flex !important;
          flex-direction: row !important;
          // width: 35%;
          justify-content: space-around;
        }
        .login-buttons > * {
          margin: 0 10px 0 10px;
        }

        img {
          width: 50px;
        }

        .linkcolor { 
          color: #3a6d2c;
        }
        .navbar-toggler-icon {
          background: #3a6d2c !important;
          height: 3px;
        }
        .navbar-toggler-icon:hover {
          background: yellow !important;
        }
      
      `}
      </style>
      <div className="nav-container">
        <Navbar color="light" expand="md" container={false}>
          <Container>
            <NavbarBrand className="logo">
              <img src="https://imgs.search.brave.com/zv0Es_hrAon1fbkKxIMYV9-59ksL1m0ocJSFXFikavY/rs:fit:1200:1200:1/g:ce/aHR0cHM6Ly93d3cu/cGluY2xpcGFydC5j/b20vcGljZGlyL2Jp/Zy8xMDMtMTAzNTA0/NF9iYXRhdmlhLWxh/bmRzY2FwaW5nLXBh/dmluZy1hbmQtcGF0/aW9zLWxlYWYtY2ly/Y2xlLWxvZ28ucG5n" />
            </NavbarBrand>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              <Nav className="mr-auto" navbar>
                <NavItem>
                  <NavLink
                    tag={RouterNavLink}
                    to="/"
                    exact
                    activeClassName="router-link-exact-active"
                    className="linkcolor"
                  >
                    Home
                  </NavLink>
                </NavItem>
                {isAuthenticated && (
                  <NavItem>
                    <NavLink
                      tag={RouterNavLink}
                      to="/permissions"
                      exact
                      activeClassName="router-link-exact-active"
                      className="linkcolor"
                    >
                      Permissions
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              <Nav className="d-none d-md-block login-buttons" navbar>
                {!isAuthenticated && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      id="profileDropDown"
                      className="linkcolor"
                    >
                      Customers
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => {
                          // login(brands['hawk']);
                          loginWithRedirect();
                        }}
                        className="linkcolor"
                      >
                        Login
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          loginWithRedirect({
                            authorizationParams: { connection: "sms" },
                          });
                        }}
                        className="linkcolor"
                      >
                        SMS
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          loginWithRedirect({
                            authorizationParams: { connection: "email" },
                          });
                        }}
                        className="linkcolor"
                      >
                        Email
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
                {!isAuthenticated && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      id="profileDropDown"
                      className="linkcolor"
                    >
                      Companies
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => {
                          // login(brands['hawk']);
                          window.open(
                            "https://atko-mv-org.vercel.app",
                            "_blank"
                          );
                        }}
                        className="linkcolor"
                      >
                        Portal
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
                {isAuthenticated && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret id="profileDropDown">
                      <img
                        src={user.picture}
                        alt="Profile"
                        className="nav-user-profile rounded-circle"
                        width="50"
                      />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem header>{user.name}</DropdownItem>
                      <DropdownItem
                        tag={RouterNavLink}
                        to="/profile"
                        className="dropdown-profile"
                        activeClassName="router-link-exact-active"
                      >
                        <FontAwesomeIcon icon="user" className="mr-3" /> Profile
                      </DropdownItem>
                      <DropdownItem
                        id="qsLogoutBtn"
                        onClick={() => logoutWithRedirect()}
                      >
                        <FontAwesomeIcon icon="power-off" className="mr-3" />{" "}
                        Log out
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
              </Nav>
              {/* {!isAuthenticated && (
                <Nav className="d-md-none" navbar>
                  <NavItem>
                    <Button
                      id="qsLoginBtn"
                      color="primary"
                      block
                      onClick={() => loginWithRedirect({})}
                    >
                      Log in
                    </Button>
                  </NavItem>
                </Nav>
              )} */}
              {isAuthenticated && (
                <Nav
                  className="d-md-none justify-content-between"
                  navbar
                  style={{ minHeight: 170 }}
                >
                  <NavItem>
                    <span className="user-info">
                      <img
                        src={user.picture}
                        alt="Profile"
                        className="nav-user-profile d-inline-block rounded-circle mr-3"
                        width="50"
                      />
                      <h6 className="d-inline-block">{user.name}</h6>
                    </span>
                  </NavItem>
                  <NavItem>
                    <FontAwesomeIcon icon="user" className="mr-3" />
                    <RouterNavLink
                      to="/profile"
                      activeClassName="router-link-exact-active"
                    >
                      Profile
                    </RouterNavLink>
                  </NavItem>
                  <NavItem>
                    <FontAwesomeIcon icon="power-off" className="mr-3" />
                    <RouterNavLink
                      to="#"
                      id="qsLogoutBtn"
                      onClick={() => logoutWithRedirect()}
                    >
                      Log out
                    </RouterNavLink>
                  </NavItem>
                </Nav>
              )}
            </Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default NavBar;
